export default __webpack_public_path__ + "static/boiler_b.310117240bba04ca478b698817741bb2.svg";